import vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import publicCountry from "./modules/public/country";
import publicFile from "./modules/public/file";
import user from "./modules/user";
import smses from "./modules/smses/index.js";
import recipient from "./modules/admin/recipient";
import campaign from "./modules/admin/campaign";
import company from "./modules/admin/company";
import invoice from "./modules/company-admin/invoice";
import bulkSending from "./modules/company-admin/bulk-sending";
import payment from "./modules/company-admin/payment";
import dids from "./modules/company-admin/dids";
import templates from "./modules/company-admin/templates";
import users from "./modules/company-admin/users";
import smsWorkflow from "./modules/company-admin/sms-workflow";
import reminderWorkflow from "./modules/company-admin/reminder-workflow";
import keyword from "./modules/admin/keyword";
import did from "./modules/admin/did";
import ani from "./modules/admin/ani";
import products from './modules/products/index';
import smsUser from "./modules/company-user/sms-user";
import reseller from "./modules/admin/reseller";
import vendor from "./modules/admin/vendor";
import filter from "./modules/admin/filter";
import paymentTerm from "./modules/admin/paymentTerm";
import rateTable from "./modules/rate-table";
import mobileNetwork from "./modules/admin/mobile-network";
import routing from "./modules/routing/index";
import vendorRate from "./modules/admin/vendor-rate";
import vendorProduct from "./modules/vendor-product/index";
import rates from "./modules/rates/index";
import dashboard from "./modules/admin/dashboard";
import apiAdapter from "./modules/admin/api-adapter";
import smsc from "./modules/smsc";
import webhook from "./modules/company-admin/webhook";
import gateway from "./modules/Gateway/gateway";
import report from "./modules/admin/report";
import bulk from "./modules/bulk"

vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageHeader: document.title,
  },
  mutations: {
    setPageHeader(state, value) {
      // mutate state
      state.pageHeader = value;
    }
  },
  getters: {
    getPageHeader: state => state.pageHeader,
  },
  modules: {
    auth,
    user,
    smses,
    recipient,
    reseller,
    publicCountry,
    publicFile,
    campaign,
    company,
    dashboard,
    apiAdapter,
    products,
    bulkSending,
    invoice,
    payment,
    dids,
    templates,
    users,
    smsWorkflow,
    reminderWorkflow,
    keyword,
    did,
    ani,
    vendor,
    filter,
    paymentTerm,
    rateTable,
    rates,
    vendorRate,
    vendorProduct,
    mobileNetwork,
    routing,
    smsc,
    webhook,
    gateway,
    report,
    bulk,
    companyUser: {
      smsUser,
    }
  }
});
